module.exports = __webpack_public_path__ + "img/login8-compress.bf8f591e.png";